import React from 'react'

function CS_program_details() {
  return (
    <div>
    {/* -----------------Mobile view-------------- */}
    <div className='d-sm-block d-md-none'>
      <div className='container'>
        <div className='row'>
            <div className='col-md-12 detail_1stcomp_img'>
                <div className='Mobile_view_Program_details_1stcomp_text text-center'>
                    <h1 className='display-6'>Securing Your Future in Cyber Security</h1>
                    <p className='py-2'>Immerse yourself in the world of cybersecurity. Enroll now to fortify your skills, defend against threats, and ensure a bright future in the ever-evolving digital landscape.</p>
                </div>
                <div className='mt-4 Mobile_view_Program_details_1stcomp_text text-center'>
                    <h1 className='display-4'>Overview</h1>
                    <p className='py-2'>With our in-depth course covering key ideas, network history, operating system fundamentals, and ethical hacking principles, dive into the world of cybersecurity. Examine techniques for scanning and reconnaissance, web server security, SQL injection, malware defence, social engineering, and wireless network security. Give yourself the tools you need to recognize, stop, and handle online threats. Come learn with us in a hands-on, immersive environment that blends theory and practical skills, making sure you're ready for the ever-changing cybersecurity industry.</p>
                </div>
            </div>
            <div className='col-md-12'>
                <div>
                <div className=' Details_container shadow-lg px-3 py-4'>
                <h1 className='mobile_view_Details_text text-center  pb-2 border-bottom'>Cyber Security</h1>
                  <div className='mobile_view_Details_text'>
                    <ul className='pt-2'>
                      <li>Live conversations with industry professionals</li>
                      <li className='py-3'>Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className='py-3'>25+ Hours of Learning</li>
                      <li>Certificates from reputable MNC's around the world</li>
                    </ul>
                  </div>
                  <div className='text-center'>
                  {/* <a href=''><button className="text-white shadow-sm mt-3 fs-5 px-5 pt-1 pb-2 Pr_details_button">Enroll Now</button></a> */}
                  </div>
                </div>
                </div>
            </div>
        </div>
      </div>
    </div>

    {/* ---------------------Desktop View------------------ */}
    <div className='d-none d-md-block'>
      <div className='container'>
        <div className='row'>
            <div className='col-md-8 detail_1stcomp_img'>
                <div className='pt-3 Program_details_1stcomp_text'>
                    <h1 className='display-6'>Securing Your Future in Cyber Security</h1>
                    <p className='py-4'>Immerse yourself in the world of cybersecurity. Enroll now to fortify your skills, defend against threats, and ensure a bright future in the ever-evolving digital landscape.</p>
                </div>
                <div className='mt-3 Program_details_1stcomp_text'>
                    <h1 className='display-3'>Overview</h1>
                    <p className='py-4'>With our in-depth course covering key ideas, network history, operating system fundamentals, and ethical hacking principles, dive into the world of cybersecurity. Examine techniques for scanning and reconnaissance, web server security, SQL injection, malware defence, social engineering, and wireless network security. Give yourself the tools you need to recognize, stop, and handle online threats. Come learn with us in a hands-on, immersive environment that blends theory and practical skills, making sure you're ready for the ever-changing cybersecurity industry.</p>
                </div>
            </div>
            <div className='col-md-4'>
                <div>
                <div className=' Details_container shadow-lg px-3 pt-4 pb-5'>
                <h1 className='Details_text text-center  pb-4 pt-3 border-bottom'>Cyber Security</h1>
                  <div className='Details_text '>
                    <ul className='pt-4'>
                      <li>Live conversations with industry professionals</li>
                      <li className='py-3'>Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className='py-3'>25+ Hours of Learning</li>
                      <li>Certificates from reputable MNC's around the world</li>
                    </ul>
                  </div>
                  <div className='text-center'>
                  {/* <a href=''><button className="text-white shadow-sm mt-3 fs-5 px-5 pt-1 pb-2 Pr_details_button">Enroll Now</button></a> */}
                  </div>
                </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    </div>
  )
}

export default CS_program_details
